import { getOrganization, listRewardOrganizations } from "../../content/lookups.js";
import { useGame } from "../../app/GameProvider.js";
import { ChoiceHead } from "../shared/ChoiceHead.js";

export function RewardOrgScreen() {
  const { state, dispatch } = useGame();
  const run = state.run;
  if (!run) return null;

  const choices = run.organizationChoices.length
    ? run.organizationChoices
    : listRewardOrganizations(run.stageId).slice(0, 2).map((org) => org.id);

  return (
    <section className="screen screen-reward">
      <ChoiceHead kicker="ORG" title="組織基盤を選ぶ" />
      <div className="choices">
        {choices.map((orgId) => {
          const org = getOrganization(orgId);
          if (!org) return null;
          return (
            <button
              key={orgId}
              type="button"
              className="choice is-org"
              onClick={() => dispatch({ type: "CHOOSE_ORGANIZATION", organizationId: orgId })}
            >
              <strong>{org.name}</strong>
              <small>{org.text}</small>
            </button>
          );
        })}
      </div>
    </section>
  );
}
